// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { AccessibilityDialogsNewHelpCenterDecisionTreeService } from './decision-tree.service';

@Component({
    selector: 'accessibility-dialogs-new-help-center-decision-tree',
    templateUrl: './decision-tree.component.html',
    standalone: false,
})
export class AccessibilityDialogsNewHelpCenterDecisionTreeComponent implements OnInit {
    @Input() decisionTree!: any;

    question: any = null;

    constructor (
        private accessibilityDialogsNewHelpCenterDecisionTreeService: AccessibilityDialogsNewHelpCenterDecisionTreeService,
    ) {}

    ngOnInit (): void {
        this.question = null;
        this.accessibilityDialogsNewHelpCenterDecisionTreeService.setQuestions(this.decisionTree.questions);
        this.setNextQuestion();
    }

    /**
     * Get the Answer stack
     */
    getAnswers (): any[] {
        return this.accessibilityDialogsNewHelpCenterDecisionTreeService.getAllResults();
    }

    /**
     * Add Answer to the Answer Stack
     */
    addAnswer (answer: string | object, answerText: string): void {
        if (this.question) {
            this.accessibilityDialogsNewHelpCenterDecisionTreeService.addResult(this.question, answer, answerText);
            this.setNextQuestion();
        }
    }

    /**
     * Reset the answer stack back to defined answer
     */
    gotoAnswer (answer: any): void {
        this.accessibilityDialogsNewHelpCenterDecisionTreeService.resetToResult(answer);
        this.setNextQuestion();
    }

    /**
     * Check if a solution has been found.
     */
    hasSolution (): boolean {
        return this.question === null;
    }

    /**
     * Gets the Latest Answer Result.
     * NB! This is used to get the Solution as the question will be defined as null
     */
    getLatestAnswer (): any | undefined {
        return this.accessibilityDialogsNewHelpCenterDecisionTreeService.getLatestResult();
    }

    // PROTECTED

    /**
     * Set the new Active Question
     */
    private setNextQuestion (): void {
        this.question = this.accessibilityDialogsNewHelpCenterDecisionTreeService.getActiveQuestion();
    }
}
